import { getPreposition } from '@portal-internet/core';
import Slider from 'components/3catinfo/Slider';
import Destacat from 'components/3catinfo/Destacat';
import __isEmpty from 'lodash/isEmpty';

const getTitol = (props) => {
    const { prefixTitol = '', titol, afegirPreposicioTitol = true } = props;
    if (__isEmpty(prefixTitol) || !afegirPreposicioTitol) return titol;
    return `${prefixTitol}${getPreposition(titol)}${titol}`;
};

const TiraRanking = (props) => {
    const { items, descripcio, routePath, tag = 'h2', tema, titolClass, estilModul, infoBlocRedl, marcatgeAudiencies } = props;
    const titol = getTitol(props);
    const tagSlider = tag;
    const tagDestacat = tag === 'h2' ? 'h3' : 'p';

    return (
        <>
            {items && (
                <Slider
                    titol={titol}
                    titolClass={titolClass}
                    descripcio={descripcio}
                    format='mes-llegit'
                    className='ranking'
                    tag={tagSlider}
                    estilModul={estilModul}
                    tema={tema}
                >
                    {items.map((item, i) => (
                        <Destacat
                            format='basic'
                            estil='ranking'
                            className='noGapAfter'
                            key={`mes-llegit-destacat-ranking-vertical-${item.id}-${i}`}
                            item={item}
                            index={i + 1}
                            routePath={routePath}
                            tag={tagDestacat}
                            tipusImatge='web_slider'
                            infoBlocRedl={infoBlocRedl}
                            marcatgeAudiencies={marcatgeAudiencies}
                        />
                    ))}
                </Slider>
            )}
        </>
    );
};

export default TiraRanking;
